import React from "react";
import {I18n} from "../../../../models/I18n";
import ReportSummarySection from "../ReportSummarySection/ReportSummarySection";
import ResultColorBar from "../ResultColorBar/ResultColorBar";
import {ReportSummaryColors} from "../../constants/ReportSummaryColors";
import {AdviceSectionTypes} from "../../constants/AdviceSectionTypes";
import style from "./style/AdviceSummary.module.scss";

export enum AdviceOutcome {
    POSITIVE = "positive",
    TENTATIVE = "tentative",
    NEGATIVE = "negative",
}

export interface AdviceSummaryProps {
    title: string;
    basedOn: string;
    handle: string;
    selectionText: string;
    developmentText: string;
    evaluationText: string;
    evaluation: AdviceOutcome;
    sectionType: AdviceSectionTypes;
    i18n: I18n;
}
const AdviceSummary = ({
    title,
    basedOn,
    handle,
    selectionText,
    developmentText,
    evaluationText,
    evaluation,
    sectionType,
    i18n
}: AdviceSummaryProps) => {
    const getEvaluationColor = () => {
        switch (evaluation) {
            case AdviceOutcome.POSITIVE:
                return ReportSummaryColors.GREEN;
            case AdviceOutcome.TENTATIVE:
                return ReportSummaryColors.GREEN_FADED;
            case AdviceOutcome.NEGATIVE:
                return ReportSummaryColors.ORANGE;
            default:
                return null;
        }
    }

    return (
        <ReportSummarySection
            basedOn={basedOn}
            handle={handle}
            i18n={i18n}
            scrollToSection={null}
            showViewAll={false}
            title={title}
        >
            {sectionType !== AdviceSectionTypes.DEVELOPMENT_ADVICE && <div className={style.selectionAdvice} data-testid="selection-advice">
                <ResultColorBar
                    color={getEvaluationColor()}
                    text={evaluationText || i18n.report_summary_advice_selection_no_evaluation}
                    classes={{ root: style.adviceOutcome }}
                />
                <div>
                    {sectionType === AdviceSectionTypes.SELECTION_DEVELOPMENT_ADVICE && <h5
                        className={style.textHeader}>{i18n.report_selection_development_advice_selection_text_header}</h5>}
                    <div className={style.adviceText} dangerouslySetInnerHTML={{__html: selectionText}}/>
                </div>
            </div>}
            {sectionType !== AdviceSectionTypes.SELECTION_ADVICE && <div className={style.developmentAdvice} data-testid="development-advice">
                <div>
                    {sectionType === AdviceSectionTypes.SELECTION_DEVELOPMENT_ADVICE && <h5
                        className={style.textHeader}>{i18n.report_selection_development_advice_development_text_header}</h5>}
                    <div className={style.adviceText} dangerouslySetInnerHTML={{__html: developmentText}}/>
                </div>
            </div>}
        </ReportSummarySection>
    );
}

export default AdviceSummary;
